import { Routes, Route, Navigate } from 'react-router-dom'
import { ProtectedRoute } from './components/layout/ProtectedRoute'
import { Sidebar } from './components/layout/Sidebar'
import Login from './pages/Login'
import Register from './pages/Register'
import Acceder from './pages/Acceder'
import Pricing from './pages/Pricing'
import Onboarding from './pages/Onboarding'
import Dashboard from './pages/Dashboard'
import Clientes from './pages/Clientes'
import ClienteDetalle from './pages/ClienteDetalle'
import Scraping from './pages/Scraping'
import SLA from './pages/SLA'
import Actividad from './pages/Actividad'
import Familias from './pages/Familias'
import Scheduler from './pages/Scheduler'
import Alertas from './pages/Alertas'
import Embudo from './pages/Embudo'
import Uso from './pages/Uso'
import Prospeccion from './pages/Prospeccion'
import InformeSlaPrint from './pages/InformeSlaPrint'
import BillingSettings from './pages/BillingSettings'
import Configuracion from './pages/Configuracion'
import FlowCallback from './pages/FlowCallback'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'
import { useSchedulerJobs } from './hooks/useScraping'

function AppLayout() {
  const { data: schedulerData } = useSchedulerJobs()
  const activeJobs = schedulerData?.jobs?.length ?? 0
  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      <Sidebar activeJobs={activeJobs} />
      <main style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'auto', minWidth: 0 }}>
        <Routes>
          <Route path="/"                    element={<Dashboard />} />
          <Route path="/clientes"            element={<Clientes />} />
          <Route path="/clientes/:id"        element={<ClienteDetalle />} />
          <Route path="/scraping/:clienteId" element={<Scraping />} />
          <Route path="/sla"                 element={<SLA />} />
          <Route path="/actividad"           element={<Actividad />} />
          <Route path="/familias"            element={<Familias />} />
          <Route path="/scheduler"           element={<Scheduler />} />
          <Route path="/alertas"             element={<Alertas />} />
          <Route path="/embudo"              element={<Embudo />} />
          <Route path="/uso"                 element={<Uso />} />
          <Route path="/prospeccion"         element={<Prospeccion />} />
          <Route path="/settings/billing"    element={<BillingSettings />} />
          <Route path="/settings/cuenta"     element={<Configuracion />} />
          <Route path="*"                    element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  )
}

export default function App() {
  return (
    <Routes>
      <Route path="/login"      element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/acceder" element={<Acceder />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/pricing"    element={<Pricing />} />
      <Route path="/onboarding" element={<Onboarding />} />
      <Route path="/billing/flow-callback" element={<FlowCallback />} />
      {/* Vista imprimible del informe SLA: protegida pero sin el shell del panel
          (sin sidebar) para que el PDF salga como documento limpio */}
      <Route path="/sla/informe/print" element={
        <ProtectedRoute>
          <InformeSlaPrint />
        </ProtectedRoute>
      } />
      <Route path="/*" element={
        <ProtectedRoute>
          <AppLayout />
        </ProtectedRoute>
      } />
    </Routes>
  )
}
